import { OneCredentialDelinkTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OneCredentialDelinkTrackingSchema: Record<
  OneCredentialDelinkTrackingPoint,
  string
> = {
  [OneCredentialDelinkTrackingPoint.DelinkInitPageView]:
    'a9565a72-4bd4-4e7d-8f2b-d65e5796d590',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageContinueClick]:
    'b8516338-d20e-4847-a0ce-eb4a7c1eed72',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageCancelClick]:
    '94526ef9-67ff-4482-a474-f2c075d1d1b6',
  [OneCredentialDelinkTrackingPoint.DelinkInitPageBackClick]:
    '33f7cf1b-4160-47de-b6dc-cf9d64041188',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageView]:
    'd11c18cb-2c1b-409c-b7c1-cb3810a0585f',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageNextClick]:
    '40a6507d-c2a8-4b54-bfd0-b6103369bf23',
  [OneCredentialDelinkTrackingPoint.DelinkSetupTobAccountPageBackClick]:
    '2c8dee95-a04d-4b7f-b403-65f400e43a35',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageView]:
    '1f54d9b2-2f27-42bb-82dc-2a1719044907',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageConfirmClick]:
    'e0c545f7-bf6d-4305-b6cb-ff0c6d70409d',
  [OneCredentialDelinkTrackingPoint.DelinkSetupPasswordPageBackClick]:
    'f781ab17-38bd-4bf8-958e-307631ce923e',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageView]:
    '202b23ca-a49f-4e98-af3f-76cc14bc33b8',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageContinueClick]:
    '083f132c-5204-4892-ab47-adedb6439c5b',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessPageBackClick]:
    'cc3d1894-d8ac-40b2-852a-9d96a7b6f05b',
  [OneCredentialDelinkTrackingPoint.DelinkSuccessAction]:
    'e7f347eb-53dc-4326-85be-0b9e3b502a46',
  [OneCredentialDelinkTrackingPoint.DelinkErrorPageView]:
    '0b4715a9-942b-4f9a-af45-a89d777ab1d7',
};

export const getOneCredentialDelinkInitPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkInitPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkSetupTobAccountPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSetupTobAccountPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkSetupPasswordPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSetupPasswordPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkSuccessPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkSuccessPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};

export const getOneCredentialDelinkErrorPageTypeAndSchema = (
  trackingPoint: OneCredentialDelinkTrackingPoint
) => {
  return {
    page_type: PageType.OneCredentialDelinkErrorPage,
    schema: OneCredentialDelinkTrackingSchema[trackingPoint],
  };
};
